import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Input, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { CgDetailsMore } from "react-icons/cg";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { MdCancel } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import UserAvatar from "../../Components/CustomComponents/UserAvatar.js";
import ShopDetailsModal from "../../Components/Modals/ShopDetailsModal.js";
import {
  useDeleteQuestionMutation,
  useGetAllQuestionQuery,
} from "../../Data/services/questionApi.js";
import {
  useGetAllShopQuery,
  useUpdateShopMutation,
} from "../../Data/services/shopApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import CustomBadge from "../../Components/Badges/CustomBadge.js";
import {
  getOrderStatus,
  getOrderType,
  getShopStatus,
  shopStatus,
  statusValues,
  typeValues,
} from "../../Helper/index.js";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import _ from "lodash";
import SwitchWithLoader from "../../Components/CustomComponents/SwitchWithLoader.js";
import {
  useBlockUserMutation,
  useUnBlockUserMutation,
} from "../../Data/services/generalUserApi.js";
import { useUpdateBadgeMutation } from "../../Data/services/badgesApi.js";

const ShopManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
      is_blocked: "",
    },
  });

  const statusWatch = watch("status");
  const isBlockedWatch = watch("is_blocked");
  console.log(statusWatch);
  console.log(isBlockedWatch);

  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const filterStatusData = [
    {
      value: "all",
      label: "All",
    },
    ...shopStatus.map((value) => ({
      value: value,
      label: getShopStatus(value),
    })),
  ];

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  // MARK: Dummy Data

  // const dummyData = {
  //   data: [
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "c9c3aa8f-98fd-450f-9376-16f833e91e9c",
  //       name: "mile",
  //       firstname: "",
  //       lastname: "",
  //       address:
  //         "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan",
  //       city: "Karachi Ciffty",
  //       country: "Pakistan",
  //       postal_code: "55",
  //       state: "Sindh",
  //       ein_number: "8888",
  //       email: "mile@yopmail.com",
  //       mobile_no: "+15658686868",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: null,
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: "24.87804",
  //       longitude: "67.06860",
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "be144b3a-0da3-4e51-adb0-58e6e57e6647",
  //       name: "kile",
  //       firstname: "",
  //       lastname: "",
  //       address: "fhftx",
  //       city: "hgh",
  //       country: "katac",
  //       postal_code: "8668",
  //       state: "unity",
  //       ein_number: "33333",
  //       email: "kile@yopmail.com",
  //       mobile_no: "+18868858585",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: null,
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: "24.87803",
  //       longitude: "67.06859",
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "9342eb52-7452-4b49-a217-64543cefdfc8",
  //       name: "Faisal Zaheer",
  //       firstname: "",
  //       lastname: "",
  //       address: "",
  //       city: "",
  //       country: "",
  //       postal_code: "",
  //       state: "",
  //       ein_number: null,
  //       email: "faisal.zaheer@trangotech.com",
  //       mobile_no: null,
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: "cus_SCBG9BPdjoP1fT",
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: null,
  //       longitude: null,
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "8ef4be48-c623-436d-9808-160570da8283",
  //       name: "Test Shop Owner",
  //       firstname: "",
  //       lastname: "",
  //       address: "Bahadur Shah Zafar Road, , Karachi, Sindh, , Pakistan",
  //       city: "Karachi",
  //       country: "Pakistan",
  //       postal_code: "5522",
  //       state: "Sindh",
  //       ein_number: "84268426",
  //       email: "tshop@yopmail.com",
  //       mobile_no: "+15854272251",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: null,
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: "24.87964",
  //       longitude: "67.06576",
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "04ba1ca0-60a6-4a3e-aca5-e4a12eaa702e",
  //       name: "Azmatullah Khan",
  //       firstname: "",
  //       lastname: "",
  //       address: "",
  //       city: "",
  //       country: "",
  //       postal_code: "",
  //       state: "",
  //       ein_number: null,
  //       email: "khanazmat2k16@gmail.com",
  //       mobile_no: null,
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: "cus_S8m3MdcTJGe5Xt",
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: null,
  //       longitude: null,
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
  //       name: "shop twelve",
  //       firstname: "",
  //       lastname: "",
  //       address:
  //         "7373 Gateway Blvd, , Newark, California, 94560, United States",
  //       city: "Alameda County",
  //       country: "United States",
  //       postal_code: "94560",
  //       state: "California",
  //       ein_number: "6128769123",
  //       email: "shop12@yopmail.com",
  //       mobile_no: "+11212121212",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
  //       stripe_customer_id: "cus_RDoBH9WLLRi2XZ",
  //       stripe_connect_account_id: "acct_1QL4epBFe1Rxxliv",
  //       stripe_capabilities: true,
  //       wallet_amount: 13550,
  //       latitude: "24.87790",
  //       longitude: "67.06860",
  //       is_blocked: true,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "9646a50b-c87e-4f22-929b-12ca1fe49d64",
  //       name: "shop eleven",
  //       firstname: "",
  //       lastname: "",
  //       address: "test address",
  //       city: "karachi",
  //       country: "pakistan",
  //       postal_code: "123",
  //       state: "karachi",
  //       ein_number: "11-1121211-11",
  //       email: "shop11@yopmail.com",
  //       mobile_no: "+92456672667",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: null,
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: "9.99",
  //       longitude: "12.12345",
  //       is_blocked: true,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "e687eda4-28f5-420d-b66e-334ced87ee91",
  //       name: "shop ten",
  //       firstname: "",
  //       lastname: "",
  //       address: "test address",
  //       city: "karachi",
  //       country: "pakistan",
  //       postal_code: "123",
  //       state: "karachi",
  //       ein_number: "11-1121111-11",
  //       email: "shop10@yopmail.com",
  //       mobile_no: "+92456678667",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: null,
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 0,
  //       latitude: null,
  //       longitude: null,
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "9a822451-fa06-4d91-9040-713288116881",
  //       name: "shop",
  //       firstname: "",
  //       lastname: "",
  //       address: "hsi dud us while wise on your own ",
  //       city: "Heidi ",
  //       country: "tenor tape ",
  //       postal_code: "84364",
  //       state: "odhdu ",
  //       ein_number: "57384984",
  //       email: "shop9@yopmail.com",
  //       mobile_no: "+16468494948",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: "cus_RALe0q97PshLmd",
  //       stripe_connect_account_id: "acct_1QI1prB7hwWKsziZ",
  //       stripe_capabilities: true,
  //       wallet_amount: 124654,
  //       latitude: "24.324323",
  //       longitude: "67.423432432",
  //       is_blocked: false,
  //     },
  //     {
  //       user_type: "SHOP_OWNER",
  //       slug: "18881b82-476f-43b8-bc0c-0466e1de3b70",
  //       name: "Shopowner",
  //       firstname: "",
  //       lastname: "",
  //       address: "Loren Ipsum Dolor",
  //       city: "Sit",
  //       country: "lorem",
  //       postal_code: "1234",
  //       state: "Amet",
  //       ein_number: "81238",
  //       email: "shopowner11@yopmail.com",
  //       mobile_no: "+923351812301",
  //       image_url:
  //         "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
  //       stripe_customer_id: "cus_QhaekFKucbEQsL",
  //       stripe_connect_account_id: null,
  //       stripe_capabilities: false,
  //       wallet_amount: 1481,
  //       latitude: null,
  //       longitude: null,
  //       is_blocked: false,
  //     },
  //   ],
  //   links: {
  //     total: 2,
  //     per_page: 10,
  //     current: 1,
  //     prev: 0,
  //     next: 2,
  //     total_records: 19,
  //   },
  // };

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllShopQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
        is_blocked:
          isBlockedWatch && isBlockedWatch === "all" ? "" : isBlockedWatch,
        status: statusWatch && statusWatch === "all" ? "" : statusWatch,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const [selectedType, setSelectedType] = useState(10);
  const typeList = [
    // { label: "Pending", value: 10 },
    { label: "Approved", value: 20 },
    { label: "Rejected", value: 30 },
  ];

  const [update, { isLoading: updating }] = useUpdateShopMutation();

  const handleDynamicTypeChange = async (value, row) => {
    console.log(value);
    console.log(row);
    setSelectedType(value);

    const data = {
      status: parseInt(value),
    };

    try {
      const response = await update({
        data: data,
        id: row.id,
      }).unwrap();
      console.log(response);

      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      let response;
      if (isBlock) {
        response = await unBlockUser({ id: userSlug });
      } else {
        response = await blockUser({ id: userSlug });
      }
      console.log(response);

      if (response.data.code === 200) {
        await refetch();
        setLoading(false);
        // handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Name",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        return <UserAvatar username={cellContent} image_url={row.image_url} />;
      },
    },
    {
      dataField: "email",
      text: "Email",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        return <span className="table-column-full">{cellContent}</span>;
      },
    },
    {
      dataField: "mobile_no",
      text: "Phone",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "150px",
      },
    },
    {
      dataField: "shop_details.zipcode",
      text: "Postal code",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return cellContent ? cellContent : "-";
      },
    },
    {
      dataField: "shop_details.status",
      text: "Accepted",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          // <CustomBadge
          //   classes={`${
          //     cellContent === 10
          //       ? "bg-secondary-subtle" // grey
          //       : cellContent === 20
          //       ? "bg-success-subtle"
          //       : "bg-danger-subtle"
          //   }`}
          //   text={getShopStatus(cellContent)}
          // />
          <SelectFieldComponent
            classes={`m-0 py-2 border-0 pointer hover-border ${
              cellContent === 10
                ? "bg-secondary-subtle" // grey
                : cellContent === 20
                ? "bg-success-subtle"
                : "bg-danger-subtle"
            }`}
            firstOption={cellContent === 10 ? "Pending" : cellContent}
            optionsList={typeList}
            onSelectChange={(value) => handleDynamicTypeChange(value, row)}
          />
        );
      },
    },
    {
      dataField: "is_blocked",
      text: "Blocked",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <SwitchWithLoader
            isChecked={!row.is_blocked}
            // isLoading={isBlocking || isUnBlocking}
            onChange={() => handleBlockOrUnblock(row.id, row.is_blocked)}
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Details"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 mx-2 p-2`}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center`}
                  >
                    <CgDetailsMore />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              {/* <ToolTip placement={"top"} content={"Delete"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                </div>
              </ToolTip> */}
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {/* {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )} */}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <ShopDetailsModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Shop Management"} classes="text-black" />
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex align-items-center  gap-2 ms-auto">
              <span style={{ width: "250px" }}>
                <Input
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </span>

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      style={{ width: "200px" }}
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterStatusData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />

              <Controller
                control={control}
                name="is_blocked"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      style={{ width: "200px" }}
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />
            </div>
          </Col>
        </Row>

        {/* {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Question"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        } */}
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopManagementScreen;
